<template>
  <div>
    <div class="htmlShizWeb">
    </div>
    <div style="height: 80px"></div>
    <div class="htmlShizMobile">
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'ShortFormAPI',
  data () {
    return {
    }
  },
  created () {
    this.setStoreVariables()
    this.fetchShortForm()
    console.log(this.htmlFragments)
    setTimeout(() => {
      const divShizWeb = document.querySelector('.htmlShizWeb')
      divShizWeb.insertAdjacentHTML('beforebegin', this.htmlFragments[0].htmlWeb.trim())
      const divShizMobile = document.querySelector('.htmlShizMobile')
      divShizMobile.insertAdjacentHTML('beforebegin', this.htmlFragments[0].htmlMobile.trim())
    }, 1000)
  },
  methods: {
    ...mapActions(['fetchShortForm', 'setRouterVariables']),
    setStoreVariables () {
      const varObj = {
        gbsID: this.$route.params.id,
        raceNo: this.$route.params.raceNo,
        runnerNo: this.$route.params.runnerNo
      }
      this.setRouterVariables(varObj)
    }
  },
  computed: {
    ...mapState(['htmlFragments'])
  }
}
</script>

<style scoped>

</style>
